import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { GetterService } from '../service/getter-service.service';
import { brandInPath, brandUrl } from 'src/app/brand/brand-context';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  private readonly storageKey = 'auth_redirect_url';
  private readonly authRoutes = [
    'login',
    'forgot-password',
    'registeruser',
    'guest',
    'new-guest-checkout',
    'home',
  ];

  constructor(
    private router: Router,
    private local: GetterService
  ) {
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationStart)) {
        return;
      }

      const currentUrl = event.url;

      if (!currentUrl || currentUrl.includes('/login')) {
        return;
      }

      const normalized = this.normalize(currentUrl);

      if (normalized) {
        this.local.setSessionItem(this.storageKey, normalized);
      }
    });
  }

  capture(url: string | null | undefined): void {
    const normalized = this.normalize(url || '');
    if (normalized) {
      this.local.setSessionItem(this.storageKey, normalized);
    }
  }

  setFallback(url: string | null | undefined): void {
    if (this.local.getSessionItem(this.storageKey)) {
      return;
    }

    this.capture(url);
  }

  getStoredUrl(): string {
    const url = this.local.getSessionItem(this.storageKey);
    if (!url) {
      return this.resolveDefaultUrl();
    }

    const normalized = this.normalize(url);
    return normalized || this.resolveDefaultUrl();
  }

  clear(): void {
    this.local.removeSessionItem(this.storageKey);
  }

  navigateAfterLogin(): void {
    const target = this.getStoredUrl();
    this.clear();
    this.router.navigateByUrl(`/${target}`);
  }

  private normalize(url: string): string {
    if (!url) {
      return '';
    }

    let clean = url.trim();
    clean = clean.replace(/\?.*$/, '').replace(/#.*$/, '');

    if (!clean || clean === '/') {
      return '';
    }

    if (clean.startsWith('/')) {
      clean = clean.slice(1);
    }

    // stored in the form this visit uses: 'brand/page' on the shared host,
    // 'page' on a brand host (see brand/brand-context.ts)
    const segments = clean.split('/').filter(Boolean);
    const brand = brandInPath() ? segments[0] : '';
    const routePath = (brandInPath() ? segments.slice(1) : segments).join('/');

    if (!routePath || (brandInPath() && !brand)) {
      return '';
    }

    if (this.authRoutes.some((route) => routePath.startsWith(route))) {
      return '';
    }

    return brand ? `${brand}/${routePath}` : routePath;
  }

  /** The bare brand URL: DefaultPageGuard sends it to TemplateData.DefaultPage / the menu. */
  private resolveDefaultUrl(): string {
    return brandUrl('');
  }
}
